// extracted by mini-css-extract-plugin
export var blue = "_33-g";
export var brand = "_33-c";
export var darkGrey = "_33-f";
export var disabled = "_33-6";
export var disabledSubtle = "_33-7";
export var error = "_33-8";
export var green = "_33-h";
export var grey = "_33-e";
export var icon = "_33-0";
export var inherit = "_33-b";
export var lightGrey = "_33-d";
export var orange = "_33-j";
export var pink = "_33-l";
export var primary = "_33-1";
export var purple = "_33-m";
export var quaternary = "_33-4";
export var quinary = "_33-5";
export var red = "_33-k";
export var secondary = "_33-2";
export var success = "_33-a";
export var tertiary = "_33-3";
export var warning = "_33-9";
export var white = "_33-n";
export var yellow = "_33-i";